import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;
const apiKey = process.env.REACT_APP_API_KEY;

/**
 * Fetches data from the specified URL.
 *
 * @param endpoint The URL to fetch data from.
 * @param options Additional options for the fetch request.
 * @throws {Error} If an error occurs while fetching the data.
 * @returns {Promise<any>} A promise that resolves to the fetched data.
 */
export const fetcher = async (endpoint: string, options?: any): Promise<any> => {
  const headers = {
    "Content-Type": "application/json",
    "Accept": "application/json",
    Authorization: `Bearer ${apiKey}`,
    ...(options?.headers ?? {}),
  };

  const fetchOptions = {
    ...(options ?? {}),
    method: options?.method ?? 'GET',
    headers
  };

  const response = await fetch(`${apiUrl}${endpoint}`, fetchOptions);

  if (!response.ok) {
    if (response.status === 401) {
      // maybe logout user here
    }
    const error: Error & { info?: any, status?: number } = new Error('Failed to fetch data');
    error.info = await response.json();
    error.status = response.status;
    throw error;
  }

  return response.json();
};


export const axiosClient = axios.create({
  baseURL: apiUrl,
  headers: {
    'Content-Type': 'application/json',
    "Accept": "application/json",
    Authorization: `Bearer ${apiKey}`
  },
});